import { useEffect } from 'react';
import SummaryMonth from '../../controls/summary/SummaryMonth';
import LoadingComponent from '../../layout/LoadingComponent';
import { useStore } from '../../stores/Store';

const LastMonthSummary = () => {
  const { summaryStore } = useStore();
  const { lastMonthSummary } = summaryStore;

  useEffect(() => {
    summaryStore.loadLastMonth();
  }, [summaryStore]);

  if (summaryStore.loading) {
    return <LoadingComponent />;
  }

  if (
    !lastMonthSummary ||
    (lastMonthSummary.expenseTypeTotals.length === 0 &&
      lastMonthSummary.incomeTypeTotals.length === 0)
  ) {
    return (
      <h3 style={{ textAlign: 'center', paddingTop: 100 }}>
        There is no data available for the selected month.
      </h3>
    );
  }

  return <SummaryMonth monthlySummary={lastMonthSummary} />;
};

export default LastMonthSummary;
